<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content>
  <form [formGroup]="editMktAreaForm">
    <strong>{{ mktArea }}</strong>
    <br/>

    <mat-form-field>
      <mat-label>Available Planning Markets</mat-label>
      <fab-multiselect
        formControlName="planningMarketMappingList"
        [options]="this.planningMarkets.options"
      >
      </fab-multiselect>
      <mat-error *ngIf="editMktAreaForm.get('planningMarketMappingList').hasError('required')">
        A value is <strong>required</strong>.
      </mat-error>
    </mat-form-field>
    <div id="actions-container">
      <button mat-stroked-button id="cancel-button" class="action-button" (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" id="edit-button" class="action-button"
              (click)="editValue()" [disabled]="!editMktAreaForm.valid">
        Save
      </button>
    </div>
  </form>
</div>
<div mat-dialog-content class="popUp">

  <div class="gfs-table">
    <mat-table id="mainTable" [dataSource]="dataSource"
               aria-label="Market Area Planning Market map Table">

      <ng-container matColumnDef="plngMkt">
        <mat-header-cell *matHeaderCellDef> Planning Markets</mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index"> {{ element }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="footer" [sticky]="true">
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      <mat-footer-row class="bottom-border" *matFooterRowDef="['footer']; sticky: true"></mat-footer-row>
    </mat-table>
  </div>

</div>
